import React from 'react';
import GameBase from '../components/base/game-base';

const ChampionshipRulesGame = () => {
  return <GameBase sportType="general" />;
};

export default ChampionshipRulesGame;
